import {
  Flex,
  Text,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
} from '@chakra-ui/react';

const ErrorModal = ({
  isOpen,
  onClose,
  message,
}: {
  isOpen: boolean;
  onClose: () => void;
  message: string;
}): JSX.Element => (
  <Modal isOpen={isOpen} onClose={onClose}>
    <ModalOverlay />
    <ModalContent
      bg="#0F6299"
      alignSelf="center"
      color="white"
      maxWidth={['80%', '70%', '60%', '50%']}
    >
      <ModalHeader fontWeight={600} fontSize="24px" lineHeight="28.18px">
        Error!
      </ModalHeader>
      <ModalBody>
        <Text
          fontWeight={700}
          fontSize="14px"
          lineHeight="16.8px"
          letterSpacing="5%"
        >
          {message}
        </Text>
        <Flex justifyContent="flex-end" mt={4}>
          <Button
            border="none"
            bg="transparent"
            fontWeight={700}
            fontSize="16px"
            lineHeight="19.2px"
            letterSpacing="3%"
            onClick={onClose}
          >
            Got it
          </Button>
        </Flex>
      </ModalBody>
    </ModalContent>
  </Modal>
);

export default ErrorModal;
